import { Component, OnInit } from "@angular/core";
import { CommonService } from "../../services";
import { ReportService } from "../../services/report.service";
import { appSettings } from "../../settings";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-report",
  templateUrl: "./report.component.html",
  styleUrls: ["./report.component.scss"]
})
export class ReportComponent implements OnInit {
  loading: boolean = false;
  reportTypeArr: Array<any> = [
    {
      value: "REPORT1",
      label: "Report I (Stores without location on the putwall)"
    },
    {
      value: "REPORT2",
      label: "Report II (Stores with multiple orders in process)"
    },
    {
      value: "REPORT3",
      label: "Report III (Stores & waves with status in putwall)"
    }
  ];
  selReportType: string = "REPORT1";
  columns: Array<any> = [];
  rows: Array<any> = [];
  selectedReportName: string;
  pageSize: number = 20;
  pageNumber: number = 1;
  totalRecordCount: number = 0;
  customClasses = {
    sortAscending: 'fa fa-sort-asc',
    sortDescending: 'fa fa-sort-desc',
    pagerLeftArrow: 'fa fa-chevron-left',
    pagerRightArrow: 'fa fa-chevron-right',
    pagerPrevious: 'fa fa-step-backward',
    pagerNext: 'fa fa-step-forward'
  };

  constructor(private _commonService: CommonService,
    private _reportService: ReportService) { }

  ngOnInit() {
    document.getElementById("pageTitle").innerText = "Report";
    this.loadReport(this.selReportType);
  }

  facilityChanged(event) {
    // facility/Customer changed in Header
  }

  onChange(event) {
    // report type changed
    this.pageNumber = 1;
    this.loadReport(this.selReportType);
  }

  loadReport(reportType) {
    this.loadColumns(reportType);
    console.log("load Reports ", reportType);
    let userPref = this._commonService.getUserPreference();
    this.rows = [];
    this.totalRecordCount = 0;
    this.loading = true;
    console.time('getReports');
    this._reportService.getReportsPaged(reportType, userPref.FacilityId, userPref.CustomerId, this.pageSize, this.pageNumber)
      .subscribe(response => {
        console.timeEnd('getReports');
        console.log("getReports ", response);
        this.rows = response.Records;
        this.totalRecordCount = response.TotalRecords;
        this.loading = false;
      },
        err => {
          console.timeEnd('getReports');
          console.log("getReports ", err);
          this.loading = false;
        }
      );
  }

  setPage(pageNum) {
    this.pageNumber = pageNum;
    this.loadReport(this.selReportType);
  }

  loadColumns(reportType) {
    switch (reportType) {
      case "REPORT1":
        this.selectedReportName = "Report I (Stores without location on the putwall)";
        this.columns = [
          { field: "OrderId", label: "Order Id" },
          { field: "WaveCode", label: "Wave Code" },
          { field: "WaveStatusDescr", label: "Wave Status" },
          { field: "StoreCode", label: "Store Code" }
        ];
        break;

      case "REPORT2":
        this.selectedReportName = "Report II (Stores with multiple orders in process)";
        this.columns = [
          { field: "OrderCount", label: "Order #" },
          { field: "WaveCode", label: "Wave Code" },
          { field: "WaveTitle", label: "Wave Title" },
          { field: "WaveStatusDescr", label: "Wave Status" },
          { field: "StoreCode", label: "Store Code" },
          { field: "LocationCode", label: "Location Code" }
        ];
        break;

      case "REPORT3":
        this.selectedReportName = "Report III (Stores & waves with status in putwall)";
        this.columns = [
          { field: "WaveCode", label: "Wave Code" },
          { field: "WaveTitle", label: "Wave Title" },
          { field: "WaveStatusDescr", label: "Wave Status" },
          { field: "OrderId", label: "Order Id" },
          { field: "OrderCount", label: "Order Count" },
          { field: "StoreCode", label: "Store Code" },
          { field: "LocationCode", label: "Location Code" },
          { field: "OrderStatusDescr", label: "Order Status" }
        ];
        break;
    }
  }

  exportToCsv() {
    let userPref = this._commonService.getUserPreference();
    let exportFilter: any = {
      FacilityId: userPref.FacilityId,
      CustomerId: userPref.CustomerId,
      ReportType: this.selReportType
    };

    let downloadURl = environment.excelReport + JSON.stringify(exportFilter);
    console.log(downloadURl);
    window.location.href = downloadURl;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/report/report.component.ts